/**
 * The like notification's title (GH #2796, spec §3.2, strings L5–L8). The server titles a first like with its one
 * liker; the service worker and the toast retitle the one notification per comment as more likers arrive.
 */
export const likeTitle = (likers: string[], isTask: boolean) => {
  const what = isTask ? 'task' : 'comment'
  const [first = 'Someone', second] = likers
  if (likers.length >= 3) {
    return `${first} and ${likers.length - 1} others liked your ${what}`
  }
  if (second) {
    return `${first} and ${second} liked your ${what}`
  }
  return `${first} liked your ${what}`
}
